import { render, staticRenderFns } from "./dqs-error.vue?vue&type=template&id=a5f5fe28"
import script from "./dqs-error.vue?vue&type=script&lang=js"
export * from "./dqs-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports